module.exports = __webpack_public_path__ + "img/prestamos-48-hrs.a30c99b0.svg";